import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export const getGuardrailsConfigs = async () => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/guardrails/${orgId}/all`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to get guardrails configs' };
  }

  return response;
};
